import { Button } from "@nfp-tracker/components";
import { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}


export const EmptyState = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) => {
  return (
    <div
      className="mx-auto flex max-w-[400px] flex-col items-center justify-center rounded-[var(--radius-card-lg)] bg-[var(--color-surface)] px-4 py-12 text-center shadow-[var(--shadow-level-1)] animate-fade-in"
      role="region"
      aria-label="Empty State"
    >
      <div
        className="mb-4 flex items-center justify-center rounded-[var(--radius-avatar)] bg-[var(--color-glass)] p-6 shadow-[var(--shadow-brand-glow)]"
      >
        <Icon
          className="h-12 w-12 text-[var(--color-neutral-slate)]"
          aria-hidden="true"
        />
      </div>
      <h3 className="mb-2 font-display text-title font-semibold text-foreground">
        {title}
      </h3>
      <p className="mb-6 max-w-md font-body text-body text-foreground/70">
        {description}
      </p>
      {actionLabel && onAction && (
        <Button
          onClick={onAction}
          className="rounded-[var(--radius-btn)] bg-[var(--grad-primary)] px-7 py-3.5 font-semibold text-[var(--color-text-primary)] shadow-[var(--shadow-brand-glow-strong)]"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};
